import axios from 'axios';
import { orchestration } from '~/config/public';

export interface MostReadArticle {
  url: string;
  visits: number;
}
interface GetMostReadArticlesResponse {
  topBlogArticles: MostReadArticle[];
}
export const getMostReadArticles = async (numberOfArticles = 4) => {
  return await axios
    .get<GetMostReadArticlesResponse>(
      `${orchestration.url}/common/top_blog_articles/${numberOfArticles}`,
      {
        responseType: 'json'
      }
    )
    .then(res => res.data?.topBlogArticles);
};
